// src/axiosInstance.ts
import { HEADER_EMULATED_USER_BUN } from '@bechtel/ht-clients-common';
import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { ENABLE_EMULATION, envConfig } from '~/env-config';
import { getAccessToken } from './token-util';

const axiosInstance = axios.create({
  baseURL: envConfig.mediaServiceUrl,
});
const emulationEnabled = ENABLE_EMULATION.toLowerCase() === 'true';
axiosInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const accessToken = await getAccessToken();
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
      const emulatedUserBun = window.sessionStorage.getItem(HEADER_EMULATED_USER_BUN);
      if (emulationEnabled && emulatedUserBun && emulatedUserBun.trim() != '')
        config.headers[HEADER_EMULATED_USER_BUN] = emulatedUserBun;
    }
    return config;
  },
  (error) => {
    console.log('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error) => {
    console.log('Response Error:', error);
    if (error.response && error.response.status === 401) {
      console.log('Unauthorized access');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
